import { Outlet, createFileRoute, useRouterState } from '@tanstack/react-router';

import { BusinessImpactAnalysisPage } from '@/features/bcp/components/BusinessImpactAnalysisPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/bcp/bia')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.businessContinuityWorkspace'),
  }),
  component: BusinessContinuityBiaPage,
});

function BusinessContinuityBiaPage() {
  const matches = useRouterState({ select: (state) => state.matches });
  const isChildRoute = matches.some((match) => match.routeId.includes('/bcp/bia/$biaId'));

  if (isChildRoute) {
    return <Outlet />;
  }

  return <BusinessImpactAnalysisPage />;
}
